module.exports = __webpack_public_path__ + "static/img/2013_phase_function_Paper_PointsHejduk_Prediction.11126fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2013_phase_function_Paper_PointsHejduk_Prediction.png
// module id = dX2p
// module chunks = 0